import styled, { css } from 'styled-components/macro';
import { ButtonNoHoverStyles, MEDIA_QUERY_WIDTH } from '../../styles';
import { Icon, COLORS, FormLabel } from '@podiumhq/design-system';

export const CreditCardInputLayoutStyles = css`
  &:only-child {
    flex-basis: 100%;
  }

  &:not(:last-child) {
    margin-right: 16px;
  }

  @media (max-width: ${MEDIA_QUERY_WIDTH}px) {
    &:not(:only-child) {
      flex-basis: 100%;
      max-width: 100%;
    }

    &:not(:last-child) {
      margin-right: 0;
    }

    &:not(:first-child) {
      margin-top: 16px;
    }
  }
`;

export const CreditCardDetailsWrapper = styled.div`
  margin-top: 32px;
`;

export const CreditCardDetailsHeader = styled.div`
  color: ${COLORS.black.lighter};
  font-size: 16px;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 8px;
`;

export const CreditCardDetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  @media (max-width: ${MEDIA_QUERY_WIDTH}px) {
    display: block;
  }
`;

export const CreditCardDetailsInputWrapper = styled.div`
  flex: 1;

  ${CreditCardInputLayoutStyles};

  &:last-child {
    flex-basis: 12%;
  }

  .StripeElement {
    background-color: ${COLORS.silver.lightest};
    border: 1px solid
      ${({ error }) => (error ? COLORS.red.base : COLORS.grey.lighter)};
    border-radius: 4px;
    box-sizing: border-box;
    color: ${COLORS.black.lighter};
    height: 40px;
    line-height: 23px;
    margin: 8px 0;
    padding: 10px 12px;
  }

  .StripeElement--error {
    border: 1px solid ${COLORS.red.base};
    box-shadow: none;
  }

  .StripeElement--focus {
    background: ${COLORS.silver.lightest};
    border: 1px solid ${COLORS.blue.base};
    box-shadow: 0 0 0 2px rgba(76, 118, 224, 0.25);
  }

  .StripeElement--invalid {
    border: 1px solid ${COLORS.red.base};
    box-shadow: none;
  }

  ${({ id, inputErrorMessage }) =>
    inputErrorMessage &&
    `
    input[id=${id}],
    .StripeElement {
      border-color: ${COLORS.red.base};
    };
  `};
`;

export const CreditCardDetailsInputInnerWrapper = styled.div`
  position: relative;
`;

export const CreditCardDetailsInputLabel = styled(FormLabel)`
  color: ${COLORS.black.lighter};
  font-size: 14px;
  font-weight: 500;
  justify-content: space-between;
  line-height: 21px;
  margin-bottom: 8px;
  max-height: 21px;
  position: relative;
  white-space: nowrap;
`;

export const InputIconButton = styled(Icon)`
  bottom: 8px;
  position: absolute;
  right: 10px;

  ${ButtonNoHoverStyles};

  svg {
    fill: #9ea9b8;
  }
`;
